import { IS_CLIENT } from '../constants/session';
import { BZNAV_ACCESS_TOKEN } from '../constants/storage-keys';
import { FetchBody, GetFetchProps, PostFetchProps } from '../types/network';

import { getCookieData } from './cookie';

export const requestFetch = (url: string, data?: unknown, config?: RequestInit) => {
  const accessToken = (IS_CLIENT && sessionStorage.getItem(BZNAV_ACCESS_TOKEN)) ?? getCookieData(BZNAV_ACCESS_TOKEN) ?? '';
  const fetchConfig: RequestInit = Object.assign(
    {
      method: 'GET',
      mode: 'cors'
    },
    config ?? {}
  );

  fetchConfig.headers = {
    ...config?.headers,
    Authorization: ((config?.headers as Record<string, string>)?.['Authorization'] ?? accessToken) ? `Bearer ${accessToken}` : '',
    'Content-Type': (config?.headers as Record<string, string>)?.['Content-Type'] ?? 'application/json'
  };

  return fetch(url, {
    ...fetchConfig,
    body:
      fetchConfig.method !== 'GET' && data && (fetchConfig?.headers as Record<string, string>)?.['Content-Type'] === 'application/json'
        ? JSON.stringify(data)
        : undefined
  });
};

export const requestPostFetch = ({ url, data, config, signal }: PostFetchProps) => {
  const contentType = config?.contentType ?? 'application/json';
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': contentType,
      Authorization: config?.authorization ?? ''
    },
    body: (contentType === 'application/json' && data ? JSON.stringify(data) : data) as FetchBody,
    signal
  });
};

export const requestGetFetch = ({ url, config, signal }: GetFetchProps) => {
  const contentType = config?.contentType ?? 'application/json';
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': contentType,
      Authorization: config?.authorization ?? ''
    },
    signal
  });
};
